import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { County } from '../../interfaces/region-counties.interface';
import { HttpRequestService } from './http-request.service';
import { ENDPOINTS } from '../constants/url.constants';
import { ApiResponse } from '../../interfaces/response.interface';
import { TasLookupRes } from '../../interfaces/tas-lookup.interface';
import { STATIC_DATA } from '../constants/static-data.constants';
import { SectionsService } from '../../services/sections.service';
import { UserService } from '../../services/user.service';
import { StorageService } from '../../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class CountyValidationService {
  private http = inject(HttpRequestService);
  private sectionsService = inject(SectionsService);
  private storageService = inject(StorageService);
  private userService = inject(UserService);

  counties: WritableSignal<County[]> = signal([]);

  get isConsumerFlow(): boolean {
    const firstMenu = this.storageService.getFirstMenu();
    const leadSubmissionFlow = this.sectionsService.getFlow();

    if (firstMenu === 'globalConsumerSearch') {
      // If Global Consumer Search/Program
      return leadSubmissionFlow === STATIC_DATA.PROVIDER_ENROLLMENT
        ? false
        : true;
    } else if (firstMenu === 'pre_referral') {
      // If Interest Program
      const firstSegment = this.userService.getFirstSegment();
      return firstSegment === 'participantLeadsList'
      ? true
      : false
    }
    return false;
  }

  getCounties() {
    // this.fetchCountiesByTasLookup().subscribe((res) => {
    //   const counties = res.responsedata.regionCountyDetailList ?? [];
    //   const sortedCounties = this.sortCountiesByName(counties);
    //   this.counties.set(sortedCounties);
    // });
  }

  fetchCountiesByTasLookup() {
    const program = this.userService.getSelectedProgram();
    const program_code = program?.program_code ?? '';

    const payload = {
      programCode: program_code,
      payloadData: {
        lkpdomainname: ['ng_pay_region_county'],
      },
    };
    return this.http.post<ApiResponse<TasLookupRes>>(
      ENDPOINTS.GET_TAS_LOOKUP_VALUES,
      payload,
    );
  }

  isCountyValid(countyName: County['regionCountyName']): boolean {
    return this.counties().some(
      (c) => c.regionCountyName.toLowerCase() === countyName.toLowerCase(),
    );
  }

  addCounty(countyName: County['regionCountyName']) {
    let counties = this.counties();
    const county: County = {
      regionCountyName: countyName,
      payRegionId: 0,
      payRegionCountyId: 0,
    };
    counties = [...counties, county];
    const sortedCounties = this.sortCountiesByName(counties);
    this.counties.set(sortedCounties);
  }

  private sortCountiesByName(counties: County[]) {
    return counties.sort((a, b) => {
      return a.regionCountyName < b.regionCountyName
        ? -1
        : a.regionCountyName > b.regionCountyName
          ? 1
          : 0;
    });
  }
}
